import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { reset, changeValue, getSearchAddressList } from 'app/store/modules/address';

export default function useAddress() {
	const {
		address,
		currentAddress,
		buildingCd,
		addressList,
		isExist,
		region,
		state,
		postalCd,
		roadPart,
		detailPart,
		sidoCode,
		sidoName,
		sigunguCode,
		sigunguName,
	} = useSelector((store) => store.address);
	const dispatch = useDispatch();

	const getAddressList = useCallback((data) => dispatch(getSearchAddressList(data)), [dispatch]);

	const changeAddressValue = useCallback((data) => dispatch(changeValue(data)), [dispatch]);

	const resetAddressInfo = useCallback(() => dispatch(reset()), [dispatch]);

	return {
		address,
		currentAddress,
		buildingCd,
		addressList,
		isExist,
		region,
		state,
		postalCd,
		roadPart,
		detailPart,
		sidoCode,
		sidoName,
		sigunguCode,
		sigunguName,
		getAddressList,
		changeAddressValue,
		resetAddressInfo,
	};
}
